// trmgTheme.js
import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes'

const trmgTheme = definePreset(Aura, {
    // primitive: {
    //   // red: { 
    //   //   50:  '#fdf4f5', // '#fef2f2',
    //   //   100: '#fae3e4', // '#fee2e2',
    //   //   200: '#f5bfc2', // '#fecaca',
    //   //   300: '#f0989f', // '#fca5a5',
    //   //   400: '#ed727d', // '#f87171',
    //   //   500: '#e83c52', // '#ef4444',
    //   //   600: '#bc2f41', // '#dc2626',
    //   //   700: '#9b2534', // '#b91c1c',
    //   //   800: '#761a26', // '#991b1b',
    //   //   900: '#58111a', // '#7f1d1d',
    //   //   950: '#490c14', // '#450a0a'
    //   // },
    // },
    components: {
        button: {
            colorScheme: {
                light: {
                    root: {
                        // v2 — darker severity buttons (shift 500→600 base; comment block to restore Aura defaults)
                        // Aura defaults: info={sky.500}, success={green.500}, warn={orange.500}, help={purple.500}, danger={red.500}
                        info: {
                            background: '{sky.600}', hoverBackground: '{sky.700}', activeBackground: '{sky.800}',
                            borderColor: '{sky.600}', hoverBorderColor: '{sky.700}', activeBorderColor: '{sky.800}',
                            focusRing: { color: '{sky.600}', shadow: 'none' }
                        },
                        success: {
                            background: '{green.600}', hoverBackground: '{green.700}', activeBackground: '{green.800}',
                            borderColor: '{green.600}', hoverBorderColor: '{green.700}', activeBorderColor: '{green.800}',
                            focusRing: { color: '{green.600}', shadow: 'none' }
                        },
                        warn: {
                            background: '{orange.600}', hoverBackground: '{orange.700}', activeBackground: '{orange.800}',
                            borderColor: '{orange.600}', hoverBorderColor: '{orange.700}', activeBorderColor: '{orange.800}',
                            focusRing: { color: '{orange.600}', shadow: 'none' }
                        },
                        help: {
                            background: '{purple.600}', hoverBackground: '{purple.700}', activeBackground: '{purple.800}',
                            borderColor: '{purple.600}', hoverBorderColor: '{purple.700}', activeBorderColor: '{purple.800}',
                            focusRing: { color: '{purple.600}', shadow: 'none' }
                        },
                        danger: {
                            background: '{red.600}', hoverBackground: '{red.700}', activeBackground: '{red.800}',
                            borderColor: '{red.600}', hoverBorderColor: '{red.700}', activeBorderColor: '{red.800}',
                            focusRing: { color: '{red.600}', shadow: 'none' }
                        },
                    }
                }
            }
        }
    },
    semantic: {
        primary: {
            50:  'var(--color-brand-50)',
            100: 'var(--color-brand-100)',
            200: 'var(--color-brand-200)',
            300: 'var(--color-brand-300)',
            400: 'var(--color-brand-400)',
            500: 'var(--color-brand-500)',
            600: 'var(--color-brand-600)',
            700: 'var(--color-brand-700)',
            800: 'var(--color-brand-800)',
            900: 'var(--color-brand-900)',
            950: 'var(--color-brand-950)'
        },
        colorScheme: {
            light: {
                // v2 — darker button tones (comment out primary block to restore Aura defaults)
                primary: {
                    color:        'var(--color-brand-600)',
                    inverseColor: '#ffffff',
                    hoverColor:   'var(--color-brand-700)',
                    activeColor:  'var(--color-brand-800)',
                },
                surface: {
                    0: '#ffffff',
                    50: '{zinc.50}',
                    100: '{zinc.100}',
                    200: '{zinc.200}',
                    300: '{zinc.300}',
                    400: '{zinc.400}',
                    500: '{zinc.500}',
                    600: '{zinc.600}',
                    700: '{zinc.700}',
                    800: '{zinc.800}',
                    900: '{zinc.900}',
                    950: '{zinc.950}'
                }
            },
            // slightly blue dark surface
            dark: {
                surface: {
                    0: '#ffffff',
                    50: '{slate.50}',
                    100: '{slate.100}',
                    200: '{slate.200}',
                    300: '{slate.300}',
                    400: '{slate.400}',
                    500: '{slate.500}',
                    600: '{slate.600}',
                    700: '{slate.700}',
                    800: '{slate.800}',
                    900: '{slate.900}',
                    950: '{slate.950}'
                }
            }
        },
    }
});

// Noir theme (greyscale)
const noirTheme = definePreset(Aura, {
    semantic: {
        primary: {
            50:  '{zinc.50}',
            100: '{zinc.100}',
            200: '{zinc.200}',
            300: '{zinc.300}',
            400: '{zinc.400}',
            500: '{zinc.500}',
            600: '{zinc.600}',
            700: '{zinc.700}',
            800: '{zinc.800}',
            900: '{zinc.900}',
            950: '{zinc.950}'
        },
        colorScheme: {
            light: {
                primary: {
                    color: '{zinc.950}',
                    inverseColor: '#ffffff',
                    hoverColor: '{zinc.900}',
                    activeColor: '{zinc.800}'
                },
                highlight: {
                    background: '{zinc.950}',
                    focusBackground: '{zinc.700}',
                    color: '#ffffff',
                    focusColor: '#ffffff'
                }
            },
            dark: {
                primary: {
                    color: '{zinc.50}',
                    inverseColor: '{zinc.950}',
                    hoverColor: '{zinc.100}',
                    activeColor: '{zinc.200}'
                },
                highlight: {
                    background: 'rgba(250, 250, 250, .16)',
                    focusBackground: 'rgba(250, 250, 250, .24)',
                    color: 'rgba(255,255,255,.87)',
                    focusColor: 'rgba(255,255,255,.87)'
                }
            }
        }
    }
});
export default trmgTheme;